import type { CartSummary } from "@wbly/data-storefront";
import { Icon } from "@wbly/ui/Icon";
import { iconsaxArrowDown } from "@wbly/tokens/icon";
import { Input } from "@wbly/ui";
import { parsePrismicRichText } from "../../../util/parse-prismic-rich-text";
import styles from "./DiscountForm.module.css";
import { useDiscountForm } from "./useDiscountForm";

type DiscountFormProps = {
  locale: string;
  staticContent: CartSummary;
};

export function DiscountForm({ staticContent, locale }: DiscountFormProps) {
  const {
    register,
    onSubmit,
    isDiscountFormOpen,
    isDiscountFormDisabled,
    toggleDiscountFormOpen,
    error,
  } = useDiscountForm({
    defaultOpen: staticContent.expandDiscountForm,
  });

  return (
    <div className={styles.DiscountForm} data-form-open={isDiscountFormOpen}>
      <button
        className={styles["DiscountForm-trigger"]}
        onClick={() => toggleDiscountFormOpen()}
      >
        <p
          className={styles["DiscountForm-description"]}
          dangerouslySetInnerHTML={{
            __html: parsePrismicRichText(
              staticContent.discountFormDescription,
              locale
            ),
          }}
        />

        <Icon
          className={styles["DiscountForm-arrow"]}
          href={iconsaxArrowDown}
          size="small"
        />
      </button>

      <div
        className={styles["DiscountForm-formContainer"]}
        aria-hidden={isDiscountFormDisabled}
      >
        <div className={styles["DiscountForm-formInner"]}>
          <form
            aria-invalid={!!error}
            aria-disabled={isDiscountFormDisabled}
            className={[
              styles["DiscountForm-form"],
              error ? styles["DiscountForm-form--shake"] : "",
            ].join(" ")}
            onSubmit={onSubmit}
          >
            <Input
              data-testid="promo-code-input"
              aria-label={staticContent.discountFormPlaceholder}
              className={styles["DiscountForm-form-codeInput"]}
              disabled={isDiscountFormDisabled}
              placeholder={staticContent.discountFormPlaceholder}
              type="text"
              {...register("code")}
            />

            <button
              data-testid="promo-code-submit"
              className={styles["DiscountForm-form-codeSubmit"]}
              disabled={isDiscountFormDisabled}
              type="submit"
            >
              {staticContent.discountFormAddCodeCtaText}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
